import React from 'react';
import { Menu, Typography } from 'antd';
import { Link } from 'react-router-dom';
import history from '../../../../redux/history';
import { useDispatch } from 'react-redux';
import { changeTitle } from '../../../../redux/actions/app';
import Icon from '@ant-design/icons';
import { TitleAction } from '../../shared-components/TitleAction';
import * as ROUTES from '../../../../routes';

import styles from '../LeftMenuSidebar/left-menu-sidebar.module.sass';
import { HistoryOutlined } from '@ant-design/icons';

export function QueryHistorySubMenu(props) {
  const dispatch = useDispatch();
  const { Title, Text } = Typography;
  const { isKeyOn, setSessionStorage, toggleKey, ...rest } = props;

  return (
    <Menu.SubMenu
      data-cy={`leftMenuSidebarQueryHistory`}
      title={
        <TitleAction
          menuKey={'query-history'}
          title={
            <div className={styles.section_title}>
              <div className={styles.border} />
              <HistoryOutlined />
              <Title level={5}>Query History</Title>
            </div>
          }
          showDownArrow={props.isKeyOn('query-history')}
        />
      }
      className={styles.main_menu_option}
      {...rest}
    >
      {props?.mySubscriptionPlan?.has_access_to_query_history ? (
        <Menu.Item
          data-cy="queryHistorySubMenuQueryHistory"
          onClick={() => {
            dispatch(changeTitle('Query History', null));
            props.setSessionStorage('query-history-menu-item');
            history.push(ROUTES.QUERY_HISTORY);
          }}
          key="query-history-menu-item"
          disabled={!props.mySubscriptionPlan?.has_access_to_query_history}
        >
          <Link to="/query-history">
            <Text className={styles.additional_indentation} strong>
              Query History
            </Text>
          </Link>
        </Menu.Item>
      ) : (
        props.returnSubstituteMenu({
          type: 'menuItem',
          tooltipMessage: (
            <>
              Query History is not part of this subscription plan. To upgrade
              your subscription contact us at{' '}
              <a target="_blank" href="mailto:sales@silentpush.com">
                sales@silentpush.com
              </a>
              .
            </>
          ),
          menuTitle: 'Query History',
          icon: null,
        })
      )}
    </Menu.SubMenu>
  );
}
